import { render, staticRenderFns } from "./signin_company.vue?vue&type=template&id=2cc54be7&scoped=true"
import script from "./signin_company.js?vue&type=script&lang=js&external"
export * from "./signin_company.js?vue&type=script&lang=js&external"
import style0 from "./signin_company.vue?vue&type=style&index=0&id=2cc54be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc54be7",
  null
  
)

export default component.exports